/* Landing primalbull — JS extraído de la fuente.
   Lo carga layout/landing.liquid (case 'primalbull'). */


/* Contrato Shopify: un solo punto de compra para hero y sticky.
   qty = frascos físicos del combo (1 / 3 / 5). Regalos: 3 frascos = guía 1 (set primalbull-1), 5 frascos = las 2 guías (set primalbull). */
function openOrder(){
  var on = document.querySelector('.tb-bun.on');
  var qty = on ? +on.dataset.qty : 1;
  window.__primalbull_SEL = { qty: qty };
  try {
    if (qty >= 5) localStorage.setItem('te_regalo', 'primalbull|' + Date.now());
    else if (qty >= 3) localStorage.setItem('te_regalo', 'primalbull-1|' + Date.now());
    else localStorage.removeItem('te_regalo');
  } catch (e) {}
  if (window.primalbullTriggerCOD && window.primalbullTriggerCOD() !== false) return;
  window.open('https://api.whatsapp.com/send/?phone=573007290464&text=' + encodeURIComponent('Hola! Quiero pedir MOVAN Primal Bull, combo de ' + qty + ' frasco' + (qty > 1 ? 's' : '') + '.'), '_blank');
}
(function(){
  const $=s=>document.querySelector(s), $$=s=>[...document.querySelectorAll(s)];

  // 1 · countdown de 60 minutos que se reinicia
  let end; try{end=+localStorage.getItem('tbEnd')}catch(e){}
  if(!end||end<Date.now()){end=Date.now()+59*60e3+46e3;try{localStorage.setItem('tbEnd',end)}catch(e){}}
  const cd=$('#tbCd');
  setInterval(()=>{let s=Math.max(0,Math.round((end-Date.now())/1e3));if(!s){end=Date.now()+3600e3;try{localStorage.setItem('tbEnd',end)}catch(e){}}
    cd.textContent=String(Math.floor(s/60)).padStart(2,'0')+':'+String(s%60).padStart(2,'0')},1000);

  // carrusel genérico: track con scroll-snap + puntos + flechas
  function car(track,dots,onIdx){
    const items=[...track.children];
    if(dots){dots.innerHTML=items.map((_,i)=>'<i'+(i?'':' class="on"')+'></i>').join('')}
    const idx=()=>{const l=track.getBoundingClientRect().left;let b=0,d=1e9;items.forEach((it,i)=>{const x=Math.abs(it.getBoundingClientRect().left-l-(parseFloat(getComputedStyle(track).paddingLeft)||0));if(x<d){d=x;b=i}});return b};
    track.addEventListener('scroll',()=>{const i=idx();if(dots)[...dots.children].forEach((d,j)=>d.classList.toggle('on',j===i));onIdx&&onIdx(i,items.length)},{passive:true});
    return{go:(i)=>{i=(i+items.length)%items.length;track.scrollTo({left:items[i].offsetLeft-items[0].offsetLeft,behavior:'smooth'})},idx,n:items.length};
  }

  // 3 · galería
  const gal=car($('#tbGal'),$('#tbGalDots'),i=>$$('#tbThumbs .tb-ph').forEach((t,j)=>t.classList.toggle('on',j===i)));
  $$('.tb-gal-arr').forEach(b=>b.onclick=()=>gal.go(gal.idx()+ +b.dataset.dir));
  $('#tbThumbs').innerHTML=$$('#tbGal .tb-gal-s').map((s,i)=>'<div class="tb-ph'+(i?'':' on')+'">'+(s.querySelector('img')?'<img class="tb-gen" src="'+s.querySelector('img').getAttribute('src')+'" alt="" onerror="this.remove()">':'')+'</div>').join('');
  $$('#tbThumbs .tb-ph').forEach((t,i)=>t.onclick=()=>gal.go(i));

  // 8 · combos
  const buns=$$('.tb-bun');
  buns.forEach(b=>b.addEventListener('click',()=>{buns.forEach(x=>x.classList.remove('on'));b.classList.add('on');b.querySelector('input').checked=true;
    $('#tbStP').textContent=b.dataset.price;$('#tbSticky small').textContent=b.querySelector('.tb-bun-n b').textContent}));

  // 9 · fechas de entrega
  const M=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  const f=d=>{const x=new Date();x.setDate(x.getDate()+d);return x.getDate()+' '+M[x.getMonth()]};
  $('#tbD1').textContent=f(0);$('#tbD2').textContent=f(1);$('#tbD3').textContent=f(3)+' - '+f(5);

  // 10 · citas
  let q=0;const qt=$('#tbQ'),qn=qt.children.length;
  const qGo=i=>{q=(i+qn)%qn;qt.style.transform='translateX(-'+q*100+'%)';$$('#tbQd i').forEach((d,j)=>d.classList.toggle('on',j===q))};
  $$('[data-q]').forEach(b=>b.onclick=()=>qGo(q+ +b.dataset.q));
  setInterval(()=>qGo(q+1),7000);

  // 14 · carrusel de reseñas con paginador
  const rv=car($('#tbRv'),null,(i,n)=>$('#tbRvN').textContent=(i+1)+' / '+n);
  $$('[data-rv]').forEach(b=>b.onclick=()=>rv.go(rv.idx()+ +b.dataset.rv));

  // 16 · ingredientes con contador
  const ing=car($('#tbIng'),$('#tbIngD'),(i,n)=>$('#tbIc').innerHTML=String(i+1).padStart(2,'0')+' <small>/ '+String(n).padStart(2,'0')+'</small>');

  // 21 · filtros del FAQ
  $$('#tbFp button').forEach(b=>b.onclick=()=>{$$('#tbFp button').forEach(x=>x.classList.toggle('on',x===b));
    $$('.tb-fq').forEach(d=>d.classList.toggle('hide',b.dataset.f!=='all'&&d.dataset.c!==b.dataset.f))});

  // 22 · escribir reseña (sin backend: se agrega al tope, no persiste)
  const modal=$('#tbModal');let stars=5;
  const paint=()=>$$('#tbPick span').forEach(s=>s.classList.toggle('on',+s.dataset.v<=stars));paint();
  $$('#tbPick span').forEach(s=>s.onclick=()=>{stars=+s.dataset.v;paint()});
  $('#tbWr').onclick=()=>modal.classList.add('on');
  $('#tbCancel').onclick=()=>modal.classList.remove('on');
  modal.onclick=e=>{if(e.target===modal)modal.classList.remove('on')};
  $('#tbForm').onsubmit=e=>{e.preventDefault();const n=$('#tbFn').value.trim(),t=$('#tbFt').value.trim();if(!n||!t)return;
    const ini=n.split(/\s+/).map(w=>w[0]).join('').slice(0,2).toUpperCase();
    const c=document.createElement('div');c.className='tb-rc';
    c.innerHTML='<div class="tb-rc-av" style="background:#e06a25"></div><b></b><div class="s"></div><p></p><span class="rep">💬 Responder</span>';
    c.querySelector('.tb-rc-av').textContent=ini;c.querySelector('b').textContent=n;c.querySelector('.s').textContent='★'.repeat(stars)+'☆'.repeat(5-stars);c.querySelector('p').textContent=t;
    $('#tbRl').prepend(c);e.target.reset();stars=5;paint();modal.classList.remove('on');c.scrollIntoView({behavior:'smooth',block:'center'})};
  $('#tbMore').onclick=function(){this.textContent='Mostrando todas las reseñas recientes';this.disabled=true};

  // sticky móvil
  const buy=$('#tbCta'),st=$('#tbSticky');
  addEventListener('scroll',()=>st.classList.toggle('show',buy.getBoundingClientRect().bottom<0),{passive:true});
})();

/* ============================================================
   Releasit COD — variante activa + cantidad + disparo del modal
   Lo genera tools/apply_cod_trigger.py desde tools/cod_trigger.js.tpl.

   PATRÓN:
   NO se crean variantes-bundle. Dropi solo despacha las variantes que
   mapeó al IMPORTAR el producto; una variante creada después por API
   queda huérfana y el pedido no le llega (bug real de producción).
   Por eso el bundle es la MISMA variante de Dropi con quantity = N, y el
   total lo baja un descuento automático de Shopify (mín. N unidades).
   Así el pedido lleva las unidades físicas reales y Dropi las despacha.

   Releasit lee la cantidad de input[name="quantity"] en el DOM al abrir,
   y la variante de window.productData — pero SOLO la re-lee si se hace
   click en su botón nativo. _rsiV2.setState abre el modal con la variante
   cacheada al init, así que queda como último recurso.
   Depende de quantityControlsHidden:true en Releasit (ya global): si el
   cliente pudiera bajar la cantidad, pagaría el precio con descuento por
   menos unidades.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) {
      i.value = variantId;
      i.setAttribute('value', variantId);
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  /* Qué variante y qué cantidad está eligiendo el cliente ahora mismo.
     Siempre se lee del DOM — nunca del SKU, que Dropi reescribe. */
  function qtyOf(s) {
    var q = parseInt(s && s.qty, 10);
    if (!q) { var on = document.querySelector('[data-qty].on, [data-qty].active, [data-qty][aria-checked="true"]');
      q = on ? parseInt(on.getAttribute('data-qty'), 10) : 1; }
    return q || 1;
  }
  function current() {
    var s = window.__primalbull_SEL || {};
    var V = window.PRIMALBULL_VARIANTS || [];
    var v = V.filter(function (x) { return x.available; })[0] || V[0];
    return v ? { id: v.id, qty: qtyOf(s) } : null;
  }

  function sync() {
    var s = current();
    if (s && s.id) setVariantOnAllForms(s.id, s.qty);
    return s;
  }

  // el JS de la landing ya mueve la clase activa; aquí solo re-leemos después
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.__primalbull-no-watch')) {
      setTimeout(sync, 0);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  sync();

  window.primalbullTriggerCOD = function () {
    var s = sync();
    if (!s || !s.id) return;
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
